module.exports = __webpack_public_path__ + "img/life-skills.ec498158.svg";